import { t } from '@lingui/macro'
import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { getAllergyEmptyMessage } from '@/modules/app/utils/allergy.utils'
import { StObservationItem } from '@/modules/shared/components/observation-item/ObservationItem'

import type { AllergyIntolerance, AllergyProfileStatus } from '@/modules/app/types/HealthParameter.types'

type AllergyListProps = {
  allergies: AllergyIntolerance[]
  schemeStatus?: AllergyProfileStatus
}

export const AllergyList = ({ allergies, schemeStatus }: AllergyListProps) => {
  const theme = useTheme()

  if (allergies.length === 0) {
    return (
      <StObservationItem type='BodyMediumRegular'>
        {getAllergyEmptyMessage(schemeStatus) ??
          t({
            id: 'allergy.list.empty',
            message: 'Geen allergiegegevens gekend',
          })}
      </StObservationItem>
    )
  }

  return (
    <FlexColumn gap={theme.UI.Spacing.Space1}>
      {allergies.map((allergy, index) => {
        const reactionText = allergy.reaction
          ?.map((r) => r.text)
          .filter(Boolean)
          .join(', ')

        return (
          <StObservationItem key={`${allergy.name}-${index}`} type='BodyMediumRegular'>
            <FlexColumn gap={theme.UI.Spacing.Space1}>
              <Span type='BodyMediumRegular' style={{ fontWeight: '500' }} color={theme.Colors.Neutrals.Darker}>
                {allergy.name}
              </Span>
              {reactionText && (
                <Span type='BodyMediumRegular' color={theme.Colors.Neutrals.Darker}>
                  {reactionText}
                </Span>
              )}
            </FlexColumn>
          </StObservationItem>
        )
      })}
    </FlexColumn>
  )
}
